import React from 'react';
import { useTheme } from '@mui/material';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Badge from '@mui/material/Badge';
import useStyles from './ScrollTabs.styles';
import { ScrollTabsProps } from './ScrollTabs.props';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CancelIcon from '@mui/icons-material/Cancel';

const ScrollTabs: React.FC<ScrollTabsProps> = ({
  selectedTabIndex,
  options,
  onChangeTab,
  setSelectedTabIndex,
  onProgramRemove,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme, tabsClasses);

  const handleChangeTab = (event: React.MouseEvent<HTMLElement>, idx: number) => {
    event.stopPropagation();
    const programID = options[idx].value;
    if (programID !== '-1' && programID !== '0') {
      setSelectedTabIndex(idx);
    }
    onChangeTab(programID, options[idx].columnId, options[idx].columnIndex);
  };

  const handleRemoveProgram = (event: React.MouseEvent<SVGElement>, programId: string) => {
    event.stopPropagation();
    if (onProgramRemove && programId) {
      onProgramRemove(programId);
    }
  };

  return (
    <Tabs
      aria-label='visible arrows tabs example'
      value={selectedTabIndex > -1 ? selectedTabIndex : 0}
      variant='scrollable'
      scrollButtons
      sx={{
        ...classes.tabs,
        '& .MuiTabs-indicator': {
          display: 'none',
        },
      }}>
      {options && options.length
        ? options.map((item, idx) => {
            const isEmptyTab = item.value === '0';
            const isAddNewTab = item.value === '-1';
            const isSelectedTab = idx === selectedTabIndex;
            return (
              <Tab
                icon={
                  !isEmptyTab && !isAddNewTab ? (
                    isSelectedTab ? (
                      <CancelIcon
                        fontSize='small'
                        className='cursor-pointer ml-4'
                        onClick={(event) => handleRemoveProgram(event, item.value)}
                      />
                    ) : item.hasUpdates ? (
                      <Badge variant='dot' color='error' overlap='circular'>
                        <NotificationsIcon
                          sx={{ height: '22px', width: '22px', color: '#FFFFFF' }}
                        />
                      </Badge>
                    ) : undefined
                  ) : undefined
                }
                iconPosition='end'
                key={idx}
                label={
                  <Box
                    component='span'
                    sx={{
                      display: 'inline-block',
                      maxWidth: 170,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      textAlign: 'left',
                    }}>
                    {item.label}
                  </Box>
                }
                onClick={(event) => handleChangeTab(event, idx)}
                sx={{
                  '&.MuiTab-root': {
                    backgroundColor: isEmptyTab
                      ? 'rgba(0, 0, 0, 0.06) !important'
                      : isAddNewTab
                        ? '#ECEEF2 !important'
                        : undefined,
                    color: isAddNewTab ? '#0026A5 !important' : undefined,
                  },
                }}
              />
            );
          })
        : null}
    </Tabs>
  );
};

export default ScrollTabs;
